var map = {
	"./Covid/hero.png": "75ea",
	"./Financely/hero.png": "7daf",
	"./Hotpot/hero.png": "12a7",
	"./Linkedin/hero.png": "8749",
	"./QRPay/hero.png": "4caa",
	"./Rabbit/hero.png": "73f0",
	"./Vibeify/hero.png": "e37a",
	"./Watchlist/hero.png": "c05f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "152e";